import __request__ from "routing/request";
export function get() {
  return __request__("GET", "/mcp", null, {}, {
    "Accept": ["text/event-stream"]
  });
}
export function post(jsonrpc_message) {
  return __request__("POST", "/mcp", jsonrpc_message, {}, {
    "Accept": ["application/json"]
  });
}
